
(()=>{const ready=f=>document.readyState==='loading'?document.addEventListener('DOMContentLoaded',f):f();ready(()=>{
const mb=document.querySelector('[data-menu]'),mob=document.querySelector('[data-mobile]');
const setMobileMenu=open=>{if(!mob||!mb)return;mob.classList.toggle('open',open);mb.setAttribute('aria-expanded',String(open));};
mb?.addEventListener('click',()=>setMobileMenu(!mob?.classList.contains('open')));
mob?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMobileMenu(false)));
document.addEventListener('keydown',event=>{if(event.key==='Escape')setMobileMenu(false);});
document.addEventListener('click',event=>{if(mob?.classList.contains('open')&&!mob.contains(event.target)&&!mb?.contains(event.target))setMobileMenu(false);});
document.querySelectorAll('[data-request-ui]').forEach(initVehicleRequest);document.querySelectorAll('[data-calculator]').forEach(initCalc);document.querySelectorAll('[data-international-calculator]').forEach(initInternational);document.querySelectorAll('[data-tracking]').forEach(initTrack);document.querySelectorAll('[data-date-picker]').forEach(initDatePicker);
});
function initCalc(root){
const q=s=>root.querySelector(s),token=(root.dataset.token||'').trim(),rate=Number(root.dataset.rate||10),minimum=Number(root.dataset.minimum||750);
const from=q('[data-from]'),to=q('[data-to]'),btn=q('[data-calc]'),err=q('[data-error]'),result=q('[data-result]'),open=q('[data-open]'),contact=q('[data-contact]'),mapStatus=q('[data-mapstatus]'),mapHelp=q('[data-maphelp]');
let map,startM,endM,last;
function setMapStatus(text){if(mapStatus)mapStatus.textContent=text}
function help(msg){if(mapHelp){mapHelp.textContent=msg;mapHelp.classList.add('show')}setMapStatus('MAP ERROR')}
async function ensureMap(){
if(map)return map;if(!token)throw new Error('Mapbox token mangler. Indsæt et public token under Theme settings → Klinker system.');
if(!window.mapboxgl)throw new Error('Mapbox GL JS kunne ikke indlæses.');
mapboxgl.accessToken=token;map=new mapboxgl.Map({container:q('[data-map]'),style:'mapbox://styles/mapbox/light-v11',center:[10.1,56.1],zoom:5.3,attributionControl:true});
return await new Promise((resolve,reject)=>{map.once('load',()=>{map.resize();setMapStatus('MAP READY');resolve(map)});map.once('error',e=>reject(e.error||new Error('Mapbox style/token error')))});
}
async function requestJson(url,label){
const r=await fetch(url);if(!r.ok){let detail='';try{detail=(await r.text()).slice(0,180)}catch(e){};throw new Error(`${label}: HTTP ${r.status}${detail?' — '+detail:''}`)}return r.json();
}
async function geocode(text){
const u=`https://api.mapbox.com/search/geocode/v6/forward?q=${encodeURIComponent(text)}&country=dk%2Cfr%2Cit&limit=1&access_token=${encodeURIComponent(token)}`;
const d=await requestJson(u,'Adresseopslag fejlede');if(!d.features?.length)throw new Error(`Kunne ikke finde "${text}".`);
const f=d.features[0];return{coords:f.geometry.coordinates,name:f.properties?.full_address||f.properties?.name||text};
}
async function directions(a,b){
const c=`${a[0]},${a[1]};${b[0]},${b[1]}`,u=`https://api.mapbox.com/directions/v5/mapbox/driving/${c}?exclude=ferry&geometries=geojson&overview=full&steps=false&access_token=${encodeURIComponent(token)}`;
const d=await requestJson(u,'Ruteberegning fejlede');if(!d.routes?.length)throw new Error('Ingen vej-/brorute fundet uden færge.');return d.routes[0];
}
function marker(f){const e=document.createElement('div');Object.assign(e.style,{width:'17px',height:'17px',borderRadius:'50%',border:'2px solid #B8A276',background:f?'#B8A276':'#050B14',boxShadow:'0 0 0 7px rgba(184,162,118,.08)'});return e}
async function draw(g,a,b,an,bn){await ensureMap();const ft={type:'Feature',properties:{},geometry:g};if(map.getSource('route'))map.getSource('route').setData(ft);else{map.addSource('route',{type:'geojson',data:ft});map.addLayer({id:'routeGlow',type:'line',source:'route',paint:{'line-color':'#B8A276','line-width':9,'line-opacity':.12}});map.addLayer({id:'routeLine',type:'line',source:'route',paint:{'line-color':'#B8A276','line-width':3.2,'line-opacity':.98}})}startM?.remove();endM?.remove();startM=new mapboxgl.Marker({element:marker(false)}).setLngLat(a).addTo(map);endM=new mapboxgl.Marker({element:marker(true)}).setLngLat(b).addTo(map);const bd=new mapboxgl.LngLatBounds();g.coordinates.forEach(c=>bd.extend(c));map.fitBounds(bd,{padding:Math.min(90,innerWidth*.08),duration:900});setMapStatus('ROUTE READY')}
function hidden(){if(!last)return;const vals={'[data-hid-id]':last.id,'[data-hid-from]':last.a.name,'[data-hid-to]':last.b.name,'[data-hid-km]':last.km.toFixed(1)+' KM','[data-hid-price]':Math.round(last.price)+' KR.'};Object.entries(vals).forEach(([s,v])=>{const e=q(s);if(e)e.value=v});q('[data-summary]').innerHTML=`<strong style="color:#F5F4EF">${last.id||q('[data-request-ui]')?.dataset.referenceNote||''}</strong><br>${last.a.name}<br>→ ${last.b.name}<br><br>${last.km.toLocaleString('da-DK',{maximumFractionDigits:1})} KM / ${Math.round(last.price).toLocaleString('da-DK')} KR.`}
async function calc(){err.textContent='';mapHelp.classList.remove('show');if(!from.value.trim()||!to.value.trim()){err.textContent='Indtast både afhentning og levering.';return}btn.disabled=true;const old=btn.innerHTML;btn.textContent='BEREGNER…';try{const[a,b]=await Promise.all([geocode(from.value.trim()),geocode(to.value.trim())]);const r=await directions(a.coords,b.coords),km=r.distance/1000,p=Math.max(minimum,km*rate);last={a,b,km,price:p,id:''};q('[data-route]').textContent=`${a.name.toUpperCase()} → ${b.name.toUpperCase()}`;q('[data-distance]').textContent=km.toLocaleString('da-DK',{maximumFractionDigits:1})+' KM';q('[data-price]').textContent=Math.round(p).toLocaleString('da-DK')+' KR.';result.classList.add('ready');open.disabled=false;hidden();try{await draw(r.geometry,a.coords,b.coords,a.name,b.name)}catch(mapError){help(root.dataset.mapUnavailable)}}catch(e){console.error(e);err.textContent=e.message||'Der opstod en fejl.';help(e.message||'Mapbox fejl')}finally{btn.disabled=false;btn.innerHTML=old}}
btn?.addEventListener('click',calc);[from,to].forEach(e=>e?.addEventListener('keydown',x=>{if(x.key==='Enter')calc()}));open?.addEventListener('click',()=>{if(last){hidden();contact.classList.add('open');contact.scrollIntoView({behavior:'smooth'})}});
ensureMap().catch(e=>help(e.message||'Mapbox fejl'));
}
function initVehicleRequest(ui) {
  const form = ui.querySelector('form');
  const error = ui.querySelector('[data-request-error]');
  const success = ui.querySelector('#request-success');
  const referenceInput = form?.querySelector('[data-hid-id]');
  if (!form || !referenceInput || !error || form.dataset.requestBound) return;
  form.dataset.requestBound = 'true';

  const accountBooking = ui.dataset.customerLoggedIn === 'true';
  const storageKey = accountBooking ? 'klinker-business-booking-request-v1' : 'klinker-tracking-request-v1';
  const normalizeReference = value => {
    const raw = String(value || '').trim().toUpperCase().replace(/\s+/g, '');
    const normalized = /^KL\d{5,10}$/.test(raw) ? 'KL-' + raw.slice(2) : raw;
    return /^KL-\d{5,10}$/.test(normalized) ? normalized : '';
  };
  const validReference = value => Boolean(normalizeReference(value));
  const readSaved = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      const reference = normalizeReference(value?.reference);
      if (reference && Date.now() - value.createdAt < 86400000) return { ...value, reference };
    } catch (_) {}
    return null;
  };
  let saved = readSaved();
  let pending = false;
  let approved = false;
  const buttons = [...form.querySelectorAll('button[type="submit"]')];
  const buttonLabels = buttons.map(button => button.textContent);
  const showError = message => {
    error.textContent = message;
    error.focus();
  };
  const getPayload = () => {
    const data = new FormData(form);
    const value = key => String(data.get(key) || '').trim();
    return {
      vehicle: [value('contact[Bilmærke]'), value('contact[Model]')].filter(Boolean).join(' '),
      vin: (value('contact[VIN / stelnummer]') || value('contact[VIN-nummer]')).toUpperCase(),
      pickup: value('contact[Afhentning]'),
      destination: value('contact[Levering]'),
      email: value('contact[email]').toLowerCase(),
      customerName: value('contact[Navn]') || value('contact[name]'),
      company: value('contact[Virksomhed]'),
      phone: value('contact[Telefon]') || value('contact[phone]'),
      requestedPickup: value('contact[Ønsket afhentningsdato]') || value('contact[Ønsket afhentning]'),
      international: value('contact[Servicetype]') === 'International biltransport',
      direction: value('contact[Transportretning]'),
      routeDistance: value('contact[Distance]'),
      routeDuration: value('contact[Route time]'),
      estimatedPrice: value('contact[Estimeret pris]'),
      registered: form.querySelector('[data-registered], [data-home-registered]')?.checked ? 'Ja' : 'Nej'
    };
  };
  const setReference = reference => {
    referenceInput.value = reference;
    const summary = form.closest('[data-contact]')?.querySelector('[data-summary] strong');
    if (summary) summary.textContent = reference;
  };

  if (success) {
    form.closest('[data-contact]')?.classList.add('open');
    const receipt = success.querySelector('[data-request-receipt]');
    if (saved && receipt) {
      receipt.querySelector('[data-request-reference]').textContent = saved.reference;
      const link = new URL(ui.dataset.trackingPath || '/pages/tracking', location.origin);
      link.searchParams.set('tracking', saved.reference);
      receipt.querySelector('[data-request-track-link]').href = link.href;
      receipt.hidden = false;
    }
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
    success.focus();
    return;
  }

  form.addEventListener('submit', async event => {
    if (approved) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    error.textContent = '';
    if (!form.reportValidity()) return;
    const payload = getPayload();
    if (!payload.vehicle || !payload.pickup || !payload.destination || !payload.email) {
      showError(ui.dataset.routeError);
      return;
    }
    const fingerprint = JSON.stringify(payload);
    const submitter = event.submitter;
    pending = true;
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => {
      button.disabled = true;
      button.textContent = ui.dataset.creating;
    });

    try {
      if (!saved || saved.fingerprint !== fingerprint) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        let result;
        try {
          let response;
          if (accountBooking) {
            let idempotencyKey;
            try {
              const pendingKey = 'klinker-business-request-pending-v1';
              let pendingBooking = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
              if (!pendingBooking || pendingBooking.fingerprint !== fingerprint) {
                pendingBooking = { fingerprint, idempotencyKey: (crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(16).slice(2)) };
                sessionStorage.setItem(pendingKey, JSON.stringify(pendingBooking));
              }
              idempotencyKey = pendingBooking.idempotencyKey;
            } catch (_) {
              idempotencyKey = Date.now() + '-' + Math.random().toString(16).slice(2);
            }
            const numeric = value => {
              const parsed = Number.parseFloat(String(value || '').trim());
              return Number.isFinite(parsed) ? parsed : null;
            };
            response = await fetch('/apps/klinker-business/bookings', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                customerName: payload.customerName,
                company: payload.company,
                phone: payload.phone,
                vehicle: payload.vehicle,
                vin: payload.vin,
                pickup: payload.pickup,
                destination: payload.destination,
                requestedPickup: payload.requestedPickup,
                distanceKm: numeric(payload.routeDistance),
                estimatedPrice: numeric(payload.estimatedPrice),
                registered: payload.registered,
                idempotencyKey
              }),
              signal: controller.signal
            });
          } else {
            response = await fetch('https://dark-paper-a168.klinkerlogistics.workers.dev/', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
              signal: controller.signal
            });
          }
          const responseText = await response.text();
          try {
            result = responseText ? JSON.parse(responseText) : {};
          } catch (_) {
            throw new Error('Tracking API returned non-JSON (HTTP ' + response.status + ')');
          }
          const confirmedReference = normalizeReference(
            result.reference ?? result.trackingNumber ?? result.tracking_number ?? result.tracking
          );
          if (!response.ok || result.ok === false || result.success === false || !confirmedReference) {
            throw new Error(result.error || 'Tracking creation failed (HTTP ' + response.status + ')');
          }
          result.reference = confirmedReference;
        } finally {
          clearTimeout(timeout);
        }
        saved = { reference: result.reference, fingerprint, createdAt: Date.now() };
        try { sessionStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {}
      }
      if (JSON.stringify(getPayload()) !== fingerprint) {
        showError(ui.dataset.changedError);
        return;
      }
      setReference(saved.reference);
      buttons.forEach(button => { button.disabled = false; });
      approved = true;
      try {
        if (submitter && submitter.form === form) form.requestSubmit(submitter);
        else form.requestSubmit();
      } finally {
        approved = false;
      }
    } catch (error) {
      console.error('Klinker request/tracking creation failed:', error);
      showError(ui.dataset.requestError);
    } finally {
      pending = false;
      form.removeAttribute('aria-busy');
      buttons.forEach((button, index) => {
        button.disabled = false;
        button.textContent = buttonLabels[index];
      });
    }
  }, true);
}

function initTrack(root){
const input=root.querySelector('[data-trackinput]'),btn=root.querySelector('[data-trackbtn]'),out=root.querySelector('[data-trackresult]'),err=root.querySelector('[data-trackerror]');
const dataNode=root.querySelector('[data-trackdata]');
let items=[];
try{
  items=JSON.parse(dataNode?.textContent||'[]');
  if(!Array.isArray(items))items=[];
}catch(e){
  console.error('Klinker tracking data error',e,dataNode?.textContent);
  items=[];
}
const normalize=v=>String(v??'').trim().toUpperCase().replace(/[^A-Z0-9]/g,'');
const displayRef=x=>{
  const raw=String(x?.reference||x?.handle||'').trim().toUpperCase();
  if(/^KL\d+$/.test(normalize(raw)))return 'KL-'+normalize(raw).slice(2);
  return raw||'—';
};
function run(pushUrl=true){
  err.textContent='';out.classList.remove('show');
  const ref=normalize(input.value);
  document.dispatchEvent(new CustomEvent('klinker:tracking',{detail:{reference:/^KL\d+$/.test(ref)?'KL-'+ref.slice(2):''}}));
  if(!ref){err.textContent='Indtast dit reference-nummer, fx KL-33453.';input.focus();return}
  const x=items.find(i=>normalize(i?.reference)===ref||normalize(i?.handle)===ref);
  if(!x){
    err.textContent='Vi kunne ikke finde reference-nummeret. Kontrollér nummeret og prøv igen.';
    console.warn('Klinker tracking lookup miss',{searched:ref,available:items.map(i=>({reference:i?.reference,handle:i?.handle}))});
    return;
  }
  const shownRef=displayRef(x);
  out.querySelector('[data-outref]').textContent=shownRef;
  out.querySelector('[data-outroute]').textContent=`${x.pickup||'—'} → ${x.destination||'—'}`;
  out.querySelector('[data-outstatus]').textContent=(x.status_label||x.status||'—').toUpperCase();
  out.querySelector('[data-outexpectedpickup]').textContent=x.expected_pickup||'Afventer planlægning';
  out.querySelector('[data-outeta]').textContent=x.expected_delivery||x.eta||'Afventer planlægning';
  out.querySelector('[data-outactualpickup]').textContent=x.actual_picked_up||'—';
  out.querySelector('[data-outactualdelivery]').textContent=x.actual_delivered||'—';
  out.querySelector('[data-outupdated]').textContent=x.updated||'—';
  out.querySelector('[data-outvehicle]').textContent=x.vehicle||'—';
  out.querySelector('[data-outdocumentation]').textContent=x.documentation_status||'Ingen dokumentationsstatus registreret';
  const aliases={request:'requested',received:'requested',driverassigned:'assigned',chauffeurassigned:'assigned',assigned:'assigned',pickedup:'picked_up',picked:'picked_up',transit:'in_transit',intransit:'in_transit',complete:'delivered',completed:'delivered',delivered:'delivered',requested:'requested'};
  const statusKey=String(x.status||'').trim().toLowerCase().replace(/[^a-z0-9]/g,'');
  const status=aliases[statusKey]||String(x.status||'').trim().toLowerCase();
  const order=['requested','assigned','picked_up','in_transit','delivered'],ix=order.indexOf(status);
  out.querySelectorAll('[data-step]').forEach((e,i)=>e.classList.toggle('active',ix>=0&&i<=ix));
  out.classList.add('show');
  if(pushUrl&&history.replaceState){const u=new URL(location.href);u.searchParams.set('tracking',shownRef);history.replaceState({},'',u)}
  out.scrollIntoView({behavior:'smooth',block:'nearest'});
}
btn?.addEventListener('click',()=>run());
input?.addEventListener('keydown',e=>{if(e.key==='Enter')run()});
const param=new URLSearchParams(location.search).get('tracking');if(param){input.value=param;run(false)}
}

function initDatePicker(root){
  const display=root.querySelector('[data-date-display]');
  const calendar=root.querySelector('[data-calendar]');
  const grid=root.querySelector('[data-cal-grid]');
  const title=root.querySelector('[data-cal-title]');
  const prev=root.querySelector('[data-cal-prev]');
  const next=root.querySelector('[data-cal-next]');
  const hidden=root.querySelector('[data-date-hidden]');
  if(!display||!calendar||!grid||!title||!hidden)return;

  const today=new Date();
  today.setHours(0,0,0,0);
  let view=new Date(today.getFullYear(),today.getMonth(),1);
  let selected=null;

  const monthNames=['JANUAR','FEBRUAR','MARTS','APRIL','MAJ','JUNI','JULI','AUGUST','SEPTEMBER','OKTOBER','NOVEMBER','DECEMBER'];
  const pad=n=>String(n).padStart(2,'0');
  const iso=d=>`${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
  const pretty=d=>`${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()}`;

  function render(){
    title.textContent=`${monthNames[view.getMonth()]} ${view.getFullYear()}`;
    grid.innerHTML='';
    const firstDay=(new Date(view.getFullYear(),view.getMonth(),1).getDay()+6)%7; // Monday-first
    const days=new Date(view.getFullYear(),view.getMonth()+1,0).getDate();

    for(let i=0;i<firstDay;i++){
      const empty=document.createElement('div');
      empty.className='k-cal-empty';
      grid.appendChild(empty);
    }
    for(let day=1;day<=days;day++){
      const d=new Date(view.getFullYear(),view.getMonth(),day);
      const b=document.createElement('button');
      b.type='button';
      b.className='k-cal-day';
      b.textContent=day;
      if(d<today)b.disabled=true;
      if(d.getTime()===today.getTime())b.classList.add('today');
      if(selected&&d.getTime()===selected.getTime())b.classList.add('selected');
      b.addEventListener('click',()=>{
        selected=d;
        hidden.value=iso(d);
        display.querySelector('[data-date-label]').textContent=pretty(d);
        calendar.classList.remove('open');
        render();
      });
      grid.appendChild(b);
    }
    const prevMonth=new Date(view.getFullYear(),view.getMonth()-1,1);
    prev.disabled=prevMonth < new Date(today.getFullYear(),today.getMonth(),1);
  }

  display.addEventListener('click',()=>calendar.classList.toggle('open'));
  prev.addEventListener('click',()=>{view=new Date(view.getFullYear(),view.getMonth()-1,1);render()});
  next.addEventListener('click',()=>{view=new Date(view.getFullYear(),view.getMonth()+1,1);render()});
  document.addEventListener('click',e=>{if(!root.contains(e.target))calendar.classList.remove('open')});
  render();
}

})();


function initInternational(root) {
  const q = s => root.querySelector(s);
  const token = (root.dataset.token || '').trim();
  const from = q('[data-int-from]');
  const to = q('[data-int-to]');
  const btn = q('[data-int-calc]');
  const err = q('[data-int-error]');
  const status = q('[data-int-status]');
  const result = q('[data-int-result]');
  const mapHelp = q('[data-int-maphelp]');
  const form = q('form');
  const hiddenFrom = q('[data-hid-from]');
  const hiddenTo = q('[data-hid-to]');
  const hiddenKm = q('[data-hid-km]');
  const hiddenPrice = q('[data-hid-price]');
  const hiddenDuration = q('[data-int-duration]');
  const requestSection = q('[data-int-request-section]');
  const rate = Number(root.dataset.rate || 10);
  const minimum = Number(root.dataset.minimum || 750);
  const individualQuote = root.dataset.internationalQuote === 'true';
  let map, startMarker, endMarker, route = null;
  if (requestSection && q('#request-success')) requestSection.hidden = false;

  const setHiddenAddress = () => {
    if (hiddenFrom && !route) hiddenFrom.value = from?.value.trim() || '';
    if (hiddenTo && !route) hiddenTo.value = to?.value.trim() || '';
  };
  function invalidateRoute() {
    route = null;
    setHiddenAddress();
    result?.classList.remove('is-ready');
    if (requestSection && !q('#request-success')) requestSection.hidden = true;
    if (hiddenKm) hiddenKm.value = '';
    if (hiddenPrice) hiddenPrice.value = '';
    if (hiddenDuration) hiddenDuration.value = '';
    if (status) status.textContent = 'RUTE IKKE BEREGNET';
  }
  from?.addEventListener('input', invalidateRoute);
  to?.addEventListener('input', invalidateRoute);
  setHiddenAddress();

  function showMapError(message) {
    if (mapHelp) { mapHelp.textContent = message; mapHelp.classList.add('show'); }
    if (status) status.textContent = 'KORT / RUTE IKKE KLAR';
  }
  async function requestJson(url, label) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(label + ' (HTTP ' + response.status + ')');
    return response.json();
  }
  async function ensureMap() {
    if (map) return map;
    if (!token) throw new Error('Mapbox mangler en offentlig token i temaindstillingerne.');
    if (!window.mapboxgl) throw new Error('Mapbox-kortet kunne ikke indlæses.');
    mapboxgl.accessToken = token;
    map = new mapboxgl.Map({
      container: q('[data-int-map]'),
      style: 'mapbox://styles/mapbox/light-v11',
      center: [10.1, 56.1],
      zoom: 3.5,
      attributionControl: true
    });
    return await new Promise((resolve, reject) => {
      map.once('load', () => { map.resize(); resolve(map); });
      map.once('error', event => reject(event.error || new Error('Mapbox-kortet kunne ikke indlæses.')));
    });
  }
  async function geocode(address) {
    const url = 'https://api.mapbox.com/search/geocode/v6/forward?q=' +
      encodeURIComponent(address) +
      '&country=dk%2Cfr%2Cit&limit=1&types=address%2Cplace%2Clocality%2Cpostcode&access_token=' +
      encodeURIComponent(token);
    const data = await requestJson(url, 'Adresseopslag fejlede');
    if (!data.features?.length) throw new Error('Vi kunne ikke finde adressen: ' + address);
    const feature = data.features[0];
    return {
      coords: feature.geometry.coordinates,
      name: feature.properties?.full_address || feature.properties?.name || address
    };
  }
  async function directions(a, b) {
    const coordinates = a[0] + ',' + a[1] + ';' + b[0] + ',' + b[1];
    const url = 'https://api.mapbox.com/directions/v5/mapbox/driving/' + coordinates +
      '?exclude=ferry&geometries=geojson&overview=full&steps=false&access_token=' + encodeURIComponent(token);
    const data = await requestJson(url, 'Ruteberegning fejlede');
    if (!data.routes?.length) throw new Error('Der blev ikke fundet en kørerute uden færge. Kontrollér adresserne.');
    return data.routes[0];
  }
  function marker(end) {
    const element = document.createElement('div');
    Object.assign(element.style, {
      width: '16px', height: '16px', borderRadius: '50%',
      border: '2px solid #B8A276', background: end ? '#B8A276' : '#050B14',
      boxShadow: '0 0 0 7px rgba(184,162,118,.12)'
    });
    return element;
  }
  async function draw(geometry, a, b) {
    await ensureMap();
    const feature = {type:'Feature', properties:{}, geometry};
    if (map.getSource('international-route')) {
      map.getSource('international-route').setData(feature);
    } else {
      map.addSource('international-route', {type:'geojson', data:feature});
      map.addLayer({id:'international-route-glow',type:'line',source:'international-route',
        paint:{'line-color':'#B8A276','line-width':9,'line-opacity':.12}});
      map.addLayer({id:'international-route-line',type:'line',source:'international-route',
        paint:{'line-color':'#B8A276','line-width':3.5,'line-opacity':.98}});
    }
    startMarker?.remove(); endMarker?.remove();
    startMarker = new mapboxgl.Marker({element:marker(false)}).setLngLat(a).addTo(map);
    endMarker = new mapboxgl.Marker({element:marker(true)}).setLngLat(b).addTo(map);
    const bounds = new mapboxgl.LngLatBounds();
    geometry.coordinates.forEach(point => bounds.extend(point));
    map.fitBounds(bounds, {padding: Math.min(70, innerWidth * .07), duration: 700});
    status.textContent = 'RUTE BEREGNET';
  }
  function formatDuration(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.round((seconds % 3600) / 60);
    return hours + ' t. ' + minutes + ' min.';
  }
  async function calculate() {
    if (!from?.value.trim() || !to?.value.trim()) {
      err.textContent = 'Indtast både afhentnings- og leveringsadresse.';
      return;
    }
    err.textContent = '';
    mapHelp?.classList.remove('show');
    btn.disabled = true;
    const label = btn.textContent;
    btn.textContent = 'BEREGNER RUTE…';
    try {
      const [a, b] = await Promise.all([geocode(from.value.trim()), geocode(to.value.trim())]);
      const resultRoute = await directions(a.coords, b.coords);
      route = {a, b, km: resultRoute.distance / 1000, seconds: resultRoute.duration};
      if (!individualQuote) if (!individualQuote) route.price = Math.max(minimum, Math.round(route.km * rate));
      q('[data-int-route-name]').textContent = a.name + ' → ' + b.name;
      q('[data-int-km]').textContent = route.km.toLocaleString('da-DK', {maximumFractionDigits:1}) + ' km';
      q('[data-int-time]').textContent = formatDuration(route.seconds);
      q('[data-int-quote]').textContent = individualQuote ? 'Afklares individuelt' : route.price.toLocaleString('da-DK') + ' kr.';
      if (hiddenFrom) hiddenFrom.value = a.name;
      if (hiddenTo) hiddenTo.value = b.name;
      if (hiddenKm) hiddenKm.value = route.km.toFixed(1) + ' km';
      if (hiddenPrice) hiddenPrice.value = individualQuote ? 'Afklares individuelt – intet automatisk pristilbud' : String(route.price) + ' kr. (10 kr./km, min. ' + minimum + ' kr.)';
      if (hiddenDuration) hiddenDuration.value = formatDuration(route.seconds);
      result?.classList.add('is-ready');
      if (requestSection) requestSection.hidden = false;
      try { await draw(resultRoute.geometry, a.coords, b.coords); }
      catch (mapError) { console.warn('Ruten er beregnet, men kortet kunne ikke tegnes.', mapError); showMapError(mapError.message || 'Ruten er beregnet, men kunne ikke vises på kortet.'); }
    } catch (error) {
      console.error('International Mapbox route error', error);
      err.textContent = error.message || 'Ruten kunne ikke beregnes. Kontrollér adresserne, eller send en tilbudsanmodning uden ruteberegning.';
      showMapError('Ruten kunne ikke vises. Du kan stadig sende en tilbudsanmodning.');
      if (hiddenFrom) hiddenFrom.value = from.value.trim();
      if (hiddenTo) hiddenTo.value = to.value.trim();
      route = null;
      if (requestSection && !q('#request-success')) requestSection.hidden = true;
    } finally {
      btn.disabled = false;
      btn.textContent = label;
    }
  }
  btn?.addEventListener('click', calculate);
  [from, to].forEach(input => input?.addEventListener('keydown', event => {
    if (event.key === 'Enter') { event.preventDefault(); calculate(); }
  }));
  ensureMap().catch(error => showMapError(error.message || 'Mapbox-kortet kunne ikke indlæses.'));
}
